import { useEffect } from "react";

const InstagramRedirect = () => {
  useEffect(() => {
    try {
      const ua = navigator.userAgent || navigator.vendor || window.opera || "";

      const isInstagram = ua.includes("Instagram");
      const isFacebook = ua.includes("FBAN") || ua.includes("FBAV");
      const isWhatsApp = ua.includes("WhatsApp");

      const isAndroid = /android/i.test(ua);
      const isInApp = isInstagram || isFacebook || isWhatsApp;

      if (isInApp && isAndroid) {
        // Android: Auto redirect to Chrome browser directly
        const currentPath =
          window.location.pathname +
          window.location.search +
          window.location.hash;
        const fullURL = `intent://parambhog.com${currentPath}#Intent;scheme=https;package=com.android.chrome;end;`;
        window.location.replace(fullURL);
      }
    } catch {
      // silent fail safe
    }
  }, []);

  return null;
};

export default InstagramRedirect;
